import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3 text-right">
        Несколько групп экспериментальных животных 
        подвергают воздействию изучаемого фактора в
        разных концентрациях; затем в течение двух недель 
        регистрируют гибель животных в каждой группе. 
        Наконец, каким-либо статистическим методом 
        высчитывают дозу, которая вызывает гибель 50%
        животных, взятых в опыт (DL<sub>50</sub>) 
      </p>
  
  
      <p class="mb-3">
        А мой чёртов опыт всё не удаётся! 
      </p>
  
      <p class="mb-3">
        Ну что ещё надо, всё ввожу как положено, по часам, отмериваю, отсчитываю, реактивы ЧДА достал, хотя вон сокурсники с ординарными возятся – и надо же, 
        у них выходит, а у меня нет! 
        Разброс данных огромный, DL<sub>50</sub> от 74 до 622! 
        Ну, реактивы у меня надёжные; значит, в мышках дело? – 
        Тоже нет, той же породы и линии, что и у других: чистая лабораторная линия И-85-216. 
        Мы все её брали; так вон, они уже посчитали и диплом написали, а я всё ковыряюсь: не могу понять, что же, чёрт возьми, токсичны мои соединения или нет. 
        То дохнут от них мышки, то не дохнут. 
      </p>
  
      <p class="mb-3">
        И профессор не хочет помочь, гадина. «Учитесь методике эксперимента, – говорит, – Набивайте свои собственные шишки». 
        Набил бы я ему. 
        На хер мне эта методика эксперимента, я пойду в контору, где мне уже заранее место держат, и там… тю-тю, старый дурак, паши себе на студентов; 
        а мне лаборанточки будут соблюдать методику. 
        Кстати, давно я девочек не видел… «Погрузился в науку!»… Да гори оно всё огнём!
      </p>
  
      <p class="mb-3">
        И встав от стола, он решительно высыпал на среду №4 (для максимальной концентрации) удесятерённую дозу реагента. 
        Затем соответствующее количество добавил к другим средам, записал всё в журнал… 
        Засмеялся: «Теперь-то уж точно подохнут. 
        Не будет больше у меня разброса данных!»; и спокойно пошёл домой.
      </p>
  
  
      <p class="text-center bold mb-5">* * *</p>
  
  
      <p class="mb-3">
        И в самом деле, все подопытные животные (выращиваемые в виварии, который они сами называли «планета Земля») благополучно подохли. 
        Были определены DL<sub>50</sub> для нескольких новых химических веществ, потенциально ценных для народного хозяйства. 
        Только за один год в одной из стран нашего великого мира было израсходовано для токсикологических исследований 1 миллион 300 155 лабораторных животных; 
        во всём мире их расходуется примерно 30 миллионов. 
        Но что делать – надо! 
        Ведь без опытов на животных мы не сможем защищать нас самих, венец творения, высших существ нашего мира.
      </p>
  
      <p class="mb-3">
        А кстати, тот дурак не защитил-таки диплома. 
        Среда №4 (Правобережная Украина, река Днестр и город Одесса у её устья) уничтожены им полностью, а там у меня были свои интересы. 
        Я заложил там свои опыты, – а теперь все плоды их уничтожены этим балбесом! 
        Наука принадлежит всем, и никому не позволено превращать её в свою вотчину! 
        Даже его родители не помогли. 
        Его вышибли из университета, а я… 
        Что ж, я ставлю опыты на других аналогичных средах. 
        Слава богу, на «планете Земля» хватит населения ещё для многих наших экспериментов. 
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: `Что могут и чего не могут опыты in vitro`
}

const itemDate = {
  rus: `24 ноября 1986`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;